export default __webpack_public_path__ + "static/media/H1008.be7b6194.mp3";